const useEmailValidation = (email) => {
  const regEx = /^[\w+]+([\.-]?[\w+]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return regEx.test(email);
}

export default useEmailValidation;